import { render } from "./ConvertEnquiryToLeadsDialog.vue?vue&type=template&id=ba93b2ac"
import script from "./ConvertEnquiryToLeadsDialog.vue?vue&type=script&lang=js"
export * from "./ConvertEnquiryToLeadsDialog.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__